import { FormControl, Modal, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import GenericButton, { GenericButtonTypeEnum } from '../../../components/GenericButton';
import { getChildrenWithoutMembership } from '../../../api/group.api';
import { ChildWithoutMembership } from '../../../common/interfaces/group.interface';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import { CommonModalActionsBox, CommonModalContentBox, CommonModalWrapperBox } from '../../../common/styles/Common.styles';
import GenericPeopleDropdown from '../../../components/GenericPeopleDropdown';
import { useTranslation } from 'react-i18next';

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': { padding: 0, margin: 0 }
  }
});

const CreateChildMembershipModal: FC<{
  onClose: () => void;
  onConfirm: (selectedChildren: ChildWithoutMembership[]) => void;
  kindergartenId: string;
  groupId: string;
}> = ({ onClose, onConfirm, kindergartenId }) => {
  const { t } = useTranslation();
  const [selectedChildren, setSelectedChildren] = useState<ChildWithoutMembership[]>([]);
  const [children, setChildren] = useState<ChildWithoutMembership[]>([]);

  useEffect(() => {
    getChildren();
  }, []);
  const getChildren = async () => {
    try {
      const res = await getChildrenWithoutMembership(kindergartenId);
      setChildren(res.results ?? []);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Modal open onClose={onClose}>
      <CommonModalWrapperBox
        sx={{
          width: 520
        }}
      >
        <Typography variant="h6">{t('groups.addChildren')}</Typography>

        <CommonModalContentBox>
          <FormControl sx={{ m: 1, width: '100%' }}>
            <GenericPeopleDropdown
              label={`${t('kindergarten.tabs.children')}*`}
              options={children}
              selectedOptions={selectedChildren}
              onChange={selected => setSelectedChildren(selected as ChildWithoutMembership[])}
              isChildren={true}
            />
          </FormControl>
          <CommonModalActionsBox>
            <GenericButton buttonType={GenericButtonTypeEnum.Neutral} variant="text" onClick={onClose} label={t('common.cancel')} />
            <GenericButton
              buttonType={GenericButtonTypeEnum.Primary}
              isActive={selectedChildren.length > 0}
              onClick={() => onConfirm(selectedChildren)}
              label={t('common.save')}
            />
          </CommonModalActionsBox>
        </CommonModalContentBox>
      </CommonModalWrapperBox>
    </Modal>
  );
};

export default CreateChildMembershipModal;
